import { useQuery } from '@apollo/react-hooks';
import { useContext, useEffect, useRef } from 'react';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { CartIdContext } from '../Cart/CartIdContext';
import debounce from 'lodash.debounce';
import { useTracker } from '../../analytics/Analytics';
import { trackCartEvent } from '../../analytics/tracking';
// We only want a single tracker to be attached even if we use `useCart` in multiple places in our app
let trackerAttached = false;
function useSingleCartTracker(result) {
    var _a;
    const track = useTracker();
    useEffect(() => {
        var _a, _b;
        if (!trackerAttached) {
            trackerAttached = true;
            if (result.loading) {
            }
            else if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.cart) {
                if (result.data.cart.__optimistic) {
                }
                else {
                    track(trackCartEvent({ cart: (_b = result.data) === null || _b === void 0 ? void 0 : _b.cart }));
                }
            }
            return () => {
                trackerAttached = false;
            };
        }
    }, [result.loading, (_a = result.data) === null || _a === void 0 ? void 0 : _a.cart, track]);
}
export function useCart(cartQuery) {
    const { cartId } = useContext(CartIdContext);
    const result = useQuery(cartQuery, {
        variables: { cartId },
        skip: __IN_SERVER__
    });
    useSingleCartTracker(result);
    return { result, cart: result.data && result.data.cart };
}
const useLocalStorageCart = (refetch) => {
    const debounceRefetch = useRef(null);
    useEffect(() => {
        const listener = (e) => {
            const localStorageCart = localStorage.getItem('cartChange');
            if (e.storageArea === localStorage &&
                e.key === 'cartChange' &&
                localStorageCart) {
                if (debounceRefetch.current)
                    debounceRefetch.current.cancel();
                debounceRefetch.current = debounce(() => refetch(), 1500);
                debounceRefetch.current();
                localStorage.removeItem('cartChange');
            }
        };
        window.addEventListener('storage', listener);
        return () => {
            window.removeEventListener('storage', listener);
        };
    });
};
export default function CartProvider({ children, query }) {
    throwErrorInDev(!query, `You forgot to pass 'query' to CartProvider`);
    const { result } = useCart(query);
    useLocalStorageCart(result.refetch);
    return children(result);
}
//# sourceMappingURL=CartProvider.js.map